/**
 * Load environment configuration from backend at runtime
 * This script runs before the React app initializes
 * Stores config in window.__APP_CONFIG__ for access throughout the app
 */

(async function loadEnvConfig() {
  try {
    // Determine API URL: use VITE_API_URL if available, otherwise localhost
    const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000';

    // Fetch environment variables from backend
    const response = await fetch(`${apiUrl}/api/env`, {
      headers: {
        'Accept': 'application/json'
      }
    });

    if (response.ok) {
      const config = await response.json();
      window.__APP_CONFIG__ = config;
      console.log('[AppConfig] Loaded from backend:', config);
    } else {
      console.warn('[AppConfig] Failed to load from backend, using build-time config');
      window.__APP_CONFIG__ = {};
    }
  } catch (error) {
    console.warn('[AppConfig] Error loading from backend:', error);
    window.__APP_CONFIG__ = {};
  }
})();
